import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import {container} from "@Container";
import {ArmyListUnitAction} from "@Redux/actions";
import {TYPES} from "@Types";
import {ArmyListUnitView} from "@Selectors/builder/myArmyList/make/view/ArmyListUnitView";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import armyListUnitSlice from '@Redux/reducers/builder/armyListUnit.slice';

interface IArmyListUnitDeleteProps {
  armyListUnit: ArmyListUnitView
}

const ArmyListUnitDelete: React.FC<ArmyListUnitDeleteProps> = ({armyListUnit, cancel, toDelete}) => {

  return (
    <div className="mt-2 text-center">
      <h1><FormattedMessage {...defaultMessages.armyListUnitDeleteFormTitle} /></h1>
      <p><FormattedMessage {...defaultMessages.armyListUnitDeleteFormAction} /> <strong>{armyListUnit.name}</strong> ?</p>
      <div className="action">
        <button className="btn btn-age" type="button" onClick={() => cancel()}><FormattedMessage {...defaultMessages.formCancel} /></button>
        <button className="btn btn-age" type="button" onClick={() => toDelete(armyListUnit)}>
          <i className="fa fa-trash" aria-hidden="true"/> <FormattedMessage {...defaultMessages.formDelete} />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (_: AppState, owsProps: IArmyListUnitDeleteProps) => ({
  armyListUnit: owsProps.armyListUnit
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListUnitAction = container.get<ArmyListUnitAction>(TYPES.Actions.ArmyListUnitAction);
  return {
    toDelete: (armyListUnit: ArmyListUnitView) => dispatch(armyListUnitAction.actionDeleteArmyListUnit(armyListUnit.item)),
    cancel: () => dispatch(armyListUnitSlice.actions.cancel())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnitDelete);

type ArmyListUnitDeleteProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
